import AssetronOverlayDialog from '@assetron/web-common/components/common/AssetronOverlayDialog';
import HeaderFooterLayout from '@assetron/web-common/layout/HeaderFooterLayout';
import ResetPasswordSuccessContent from './ResetPasswordSuccessContent';

function ResetPasswordSuccess() {
  return (
    <HeaderFooterLayout>
      <AssetronOverlayDialog
        open
        isLogoVisible
        content={<ResetPasswordSuccessContent />}
        onClose={() => {}}
        isCloseVisible={false}
      />
    </HeaderFooterLayout>
  );
}

export default ResetPasswordSuccess;
